// Library methods
import { forwardRef, useMemo } from "react";
import { useTranslation } from "react-i18next";

// MUI Components
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

// Components
import ClinicStatsCard from "./ClinicStatsCard";

const ClinicStats = forwardRef(
  (
    {
      staticsData = {
        examsFinished: null,
        examsTerminated: null,
        patientsCreated: null,
        totalPatients: null,
      },
      isLoading,
      term = 0,
    },
    ref
  ) => {
    // internationalization
    const { t, i18n } = useTranslation();

    const statsInfo = useMemo(
      () => ({
        dynamicStatsToDisplay: {
          title:
            term === 0
              ? t("Today")
              : i18n.language === "fr"
                ? `7 ${t("word_last")} ${t("word_days")}`
                : `${t("word_last")} 7 ${t("word_days")}`,
          examsCompleted: {
            title: t("word_completed_exams"),
            value: staticsData?.examsFinished,
          },
          examsTerminated: {
            title: t("terminated_exams"),
            value: staticsData?.examsTerminated,
          },
          patientsCreated: {
            title: t("created_patients"),
            value: staticsData?.patientsCreated,
          },
        },
        staticStatsToDisplay: {
          title: t("word_total"),
          totalExams: {
            title: t("word_exams"),
            value: staticsData?.totalExams,
          },
          totalPatients: {
            title: t("dashboard_total_patients"),
            value: staticsData?.totalPatients,
          },
        },
      }),
      [
        term,
        t,
        i18n.language,
        staticsData?.examsFinished,
        staticsData?.examsTerminated,
        staticsData?.patientsCreated,
        staticsData?.totalExams,
        staticsData?.totalPatients,
      ]
    );

    const ListElement = () => (
      <Grid
        item
        display="flex"
        flexDirection={{ sm: "row", md: "column" }}
        mt="20px"
        gap="20px"
      >
        {Object.keys(statsInfo).map((infoKey) => (
          <Grid key={infoKey} item xs={6} md={12}>
            <ClinicStatsCard data={statsInfo[infoKey]} />
          </Grid>
        ))}
      </Grid>
    );

    return (
      <>
        <Box ref={ref} id="clinic-stats-container">
          <Typography fontWeight="bold" fontSize={{ xs: "16px", md: "20px" }}>
            {t("dashboard_title_clinic_stats")}
          </Typography>
          {ListElement()}
        </Box>
      </>
    );
  }
);

export default ClinicStats;
